import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.set-prototype-of.js";
var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
  }
  return t;
};
import toast from '@mx/vix/toast';
import modal from '@mx/vix/modal';
import axios from 'axios';
import { env } from './env';
import { bridge } from './bridge';
import { bizThenFunction, bizCatchFun } from './util';
export var ErrorLevel;
(function (ErrorLevel) {
  ErrorLevel[ErrorLevel["TOAST"] = 1] = "TOAST";
  ErrorLevel[ErrorLevel["MODAL_EXIT"] = 2] = "MODAL_EXIT";
  ErrorLevel[ErrorLevel["MODAL"] = 3] = "MODAL";
  ErrorLevel[ErrorLevel["EXIT"] = 4] = "EXIT";
  ErrorLevel[ErrorLevel["INLINE"] = 5] = "INLINE";
})(ErrorLevel || (ErrorLevel = {}));
var CustomError = /** @class */function (_super) {
  __extends(CustomError, _super);
  function CustomError(message, level, code) {
    var _this = _super.call(this, message) || this;
    _this.level = level;
    _this.code = code || 0;
    return _this;
  }
  return CustomError;
}(Error);
export var ajax = function ajax(settings) {
  // loading提示
  // 默认显示 loading toast
  switch (settings.toastType) {
    case 'hide':
      break;
    case 'loading':
    default:
      toast.show('loading', settings.toastText);
  }
  var data = addParams(settings.data);
  return axios({
    url: settings.url,
    timeout: 50000,
    data: data,
    method: settings.method || 'post'
  }).then(function (response) {
    var bizOpts = {
      response: response,
      url: settings.url,
      params: data
    };
    bizThenFunction(bizOpts, 0);
    innerSuccess(response.data, settings.toastType);
    return response.data;
  }).catch(function (error) {
    var bizCatchOpts = {
      error: error,
      url: settings.url,
      params: data
    };
    bizCatchFun(bizCatchOpts);
    if (!('level' in error)) {
      error = new CustomError('网络异常, 请检查您的网络设置', ErrorLevel.TOAST);
    }
    errorHandler(error);
  });
};
function addParams(data) {
  return __assign({}, data, {
    lat: env.lat,
    lng: env.lng,
    stid: env.stId,
    uuid: env.uuid,
    token: env.token,
    nb_app: env.app,
    nb_ci: env.cityId,
    nb_platform: env.system,
    nb_fingerprint: env.fingerprint,
    version: env.utmTerm,
    utm_term: env.utmTerm,
    utm_medium: env.utmMedium,
    utm_source: env.utmSource,
    utm_content: env.utmContent,
    utm_campaign: env.utmCampaign,
    clientEntry: env.appChannel // 发票助手入口
  });
}
// 请求成功回调函数
function innerSuccess(response, toastType) {
  if (!toastType || toastType === 'loading') {
    toast.hide();
  }
  if (!response) {
    throw new CustomError('网络异常, 请检查您的网络设置', ErrorLevel.TOAST);
  }
  if ('error' in response) {
    var error = response.error;
    throw new CustomError(error.message, error.level, error.code);
  }
}
// 错误处理
// level = 1, 显示 toast
// level = 3, 弹窗提示
// level = 2 或 4, 弹窗提示并退出页面
function errorHandler(error) {
  // 以下三种情况均跳回登录
  // 500010: // 未登录
  // 500011: // 登录信息异常
  var needLoginStatus = [500011, 114001, 500010];
  var errorCode = parseInt(error.code);
  if (needLoginStatus.indexOf(errorCode) > -1) {
    bridge.login();
    return;
  }
  switch (parseInt(error.level)) {
    case ErrorLevel.TOAST:
      toast.show('text', error.message);
      break;
    case ErrorLevel.MODAL_EXIT:
    case ErrorLevel.EXIT:
      modal.show({
        preventScroll: true,
        content: error.message,
        button: {
          text: '知道了',
          onClick: function onClick() {
            modal.hide();
            bridge.closeWebView();
          }
        }
      });
      break;
    case ErrorLevel.MODAL:
      modal.show({
        preventScroll: true,
        content: error.message,
        button: {
          text: '知道了',
          onClick: function onClick() {
            modal.hide();
          }
        }
      });
      break;
  }
}